import { Accordion } from 'components';
import { useTranslation } from 'react-i18next';
import { STextField } from './styled';
import { Box as MuiBox } from '@mui/material';
import { FormControl, JamIcon } from 'components/ui';

export default function InsAccordion() {
  const { t } = useTranslation();

  return (
    <Accordion
      title={t('INS') + ' *'}
      startAdornment={<JamIcon icon="id-card" />}
    >
      <MuiBox style={{ display: 'flex', gap: 30 }}>
        <FormControl label={t('INS ID')}>
          <STextField dataId="ins-input" name="ins" placeholder={t('INS ID')} />
        </FormControl>
      </MuiBox>
    </Accordion>
  );
}
